import { cn } from "@/lib/utils";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Helmet } from "react-helmet-async";
import { SEO } from "@/lib/constants/seo";
import { PublicRouteKey } from "@/routes/publicRoutes";
import Footer from "./Footer";
import { EcosystemProvider } from "@/providers/EcosystemProvider";

const RouteLayout = () => (
  <EcosystemProvider>
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="mx-auto flex w-full max-w-[1440px] flex-1 flex-col">
        <Helmet
          htmlAttributes={{ lang: "en" }}
          defaultTitle="Thrive Funding Programs"
          titleTemplate="%s | Thrive Funding Programs"
        />
        <Outlet />
      </div>
      <Footer />
    </div>
  </EcosystemProvider>
);

const MainLayout = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <main className={cn("mx-auto w-full max-w-[1096px] flex-1 px-4 py-8 xl:px-0 xl:py-14", className)}>{children}</main>
);

const PageLayout = ({
  children,
  className,
  pageKey,
}: {
  children: React.ReactNode;
  className?: string;
  pageKey?: PublicRouteKey;
}) => {
  const seo = pageKey ? SEO[pageKey] : undefined;

  return (
    <div>
      <Helmet>
        {seo?.title && <title>{seo.title}</title>}
        {seo?.description && <meta name="description" content={seo.description} />}
        {seo?.title && <meta property="og:title" content={seo.title} />}
        {seo?.description && <meta property="og:description" content={seo.description} />}
        {seo?.keywords && <meta name="keywords" content={seo.keywords.join(", ")} />}
      </Helmet>

      <MainLayout className={cn("text-white", className)}>{children}</MainLayout>
    </div>
  );
};

export { RouteLayout, MainLayout, PageLayout };
